export const googleAnalyticsTrackingId:string = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID || "";
export const isGoogleAnalyticsEnabled:boolean = process.env.REACT_APP_ENABLE_GOOGLE_ANALYTICS === 'true' ;